import styles from './footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {Link} from "react-router-dom";


function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.containerWrapper}>
            <div className={styles.container}>
                <Link to="/">
                    <img src="/images/white_logo.svg" alt="Logo"/>
                </Link>
            </div>
            <div className={styles.container}>
                <div className={styles.contactInfo}>
                    <p><FontAwesomeIcon icon={faPhone} className={styles.contactIcon}/>0475 73 73 70</p>
                    <p><FontAwesomeIcon icon={faEnvelope} className={styles.contactIcon}/><a href="mailto:info@bartvandevenne.be">info@bartvandevenne.be</a></p>
                    <p><FontAwesomeIcon icon={faMapMarkerAlt} className={styles.contactIcon}/>Bosstraat 42, 3560 Lummen</p>
                </div>
            </div>
                <div className={styles.container}>
                    <div className={styles.socialIcons}>
                        <a href="https://www.facebook.com/bartvandevenne.be" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                        <a href="https://www.instagram.com/bartvandevenne.be/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>

                    </div>
                </div>
            </div>
            <br/>
        </footer>
    );
}

export default Footer;
